module.exports = "/_next/static/images/dafb352d7f0725485e54c41c0a3dc763-mgm-xs.jpg";